import { VdsCard, VdsIcon, VdsTooltip } from '@volt/volt-extended-components-react';
import styles from './ChartCard.module.scss';
import { PropsWithChildren, ReactNode } from 'react';

interface ChartCardProps {
  title: string;
  tooltip?: string;
  controls: ReactNode;
  pad?: boolean;
}

export function ChartCard({
  title,
  tooltip,
  controls,
  children,
  pad = false,
}: PropsWithChildren<ChartCardProps>) {
  return (
    <VdsCard padding="spacing-00">
      <article className={`${styles.container} ${pad && styles['container--pad']}`}>
        <header className={styles.header}>
          <div className={styles.title}>
            <span>{title}</span>
            {tooltip && (
              <VdsTooltip
                event="hover"
                max-width="250px"
                position="right"
                type="standard"
                text={tooltip}
              >
                <VdsIcon
                  slot="tooltip-trigger"
                  svgIcon="information"
                  size="18px"
                  color="color-icon-medium"
                />
              </VdsTooltip>
            )}
          </div>
          {controls}
        </header>

        <div className={styles.chart}>{children}</div>
      </article>
    </VdsCard>
  );
}

export default ChartCard;
